import { createBrowserHistory } from 'history'
export default createBrowserHistory()



// WEBPACK FOOTER //
// ./src/components/utils/history.ts